var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center h-full"},[_c('toggle-button',{attrs:{"value":_vm.params.data.actionData.toggle,"color":{checked: '#35C76F', unchecked: '#EA5455', disabled: '#CCCCCC'}},on:{"change":_vm.handleChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }